var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 9.38889V13.8333C14.2222 14.3222 13.8222 14.7222 13.3333 14.7222H2.66667C2.17778 14.7222 1.77778 14.3222 1.77778 13.8333V9.38889C1.77778 8.9 1.37778 8.5 0.888889 8.5C0.4 8.5 0 8.9 0 9.38889V14.7222C0 15.7 0.8 16.5 1.77778 16.5H14.2222C15.2 16.5 16 15.7 16 14.7222V9.38889C16 8.9 15.6 8.5 15.1111 8.5C14.6222 8.5 14.2222 8.9 14.2222 9.38889ZM8.88889 9.09556L10.56 7.42444C10.9067 7.07778 11.4667 7.07778 11.8133 7.42444C12.16 7.77111 12.16 8.33111 11.8133 8.67778L8.62222 11.8689C8.27556 12.2156 7.71556 12.2156 7.36889 11.8689L4.17778 8.67778C3.83111 8.33111 3.83111 7.77111 4.17778 7.42444C4.52444 7.07778 5.08444 7.07778 5.43111 7.42444L7.11111 9.09556V1.38889C7.11111 0.9 7.51111 0.5 8 0.5C8.48889 0.5 8.88889 0.9 8.88889 1.38889V9.09556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.fe7d498cf035b567b6e92c7b1f0e3d7a.svg";
export { ForwardRef as ReactComponent };